module.exports = __webpack_public_path__ + "resources/img/img_alyac2_m.1d5a0b58c7fced80f5345dcb3baaeffa.png";